import IAALogo from '@/assets/IAA_Logo.jpg'
import { HeaderDropdown } from './HeaderDropdown'
import { FormattedMessage } from 'react-intl'
import { useRouterState } from '@tanstack/react-router'
import { TestIds } from '@/constants/testIds'

type HeaderProps = {
  /** Slide the header off-screen (mobile hide-on-scroll-down pattern). */
  hidden?: boolean
}

export function Header({ hidden = false }: HeaderProps) {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const isVerifyInfo = pathname === '/verifyInfo'

  return (
    <header
      data-testid={TestIds.header.container}
      // `transform` only moves the header visually — its controls (the
      // dropdown toggle, and any menu it opens) stay in the tab order and
      // in the accessibility tree even while off-screen. `aria-hidden`
      // removes it from screen readers, and `inert` removes it from
      // keyboard tab order and (per spec) moves focus out automatically if
      // it was inside the header when hidden, so hiding never leaves
      // keyboard/AT users stuck on invisible controls.
      aria-hidden={hidden}
      inert={hidden}
      className={`fixed top-0 left-0 w-full bg-white text-gray-900 border-t-4 border-gray-800 shadow-md z-50 flex justify-between items-center px-6 py-3 transition-transform duration-300 ease-in-out ${hidden ? '-translate-y-full' : 'translate-y-0'}`}
    >
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <img src={IAALogo} alt="IAA Logo" className="h-10 inline-block" />
        </div>
        <h2 className="text-xl font-semibold mb-2">
          <FormattedMessage id="header.title" />
        </h2>
      </div>
      {!isVerifyInfo && <HeaderDropdown />}
    </header>
  )
}
